let Localization = {
    "ar": {
    
        TableHeader: [
            "الاسم الأول",
            "اسم العائلة",
            "بريد إلكتروني  ",
            "رقم الهاتف",  
        ], 
    },
    "en": { 
        TableHeader: [
            "First Name",
            "Last Name",
            "Email  ",
            "Phone",  
        ], 
    }
}

export default Localization